import React from 'react';
import PropTypes from 'prop-types';
import StarRating from '@homeaway/react-star-rating';
import { AspectRatioCardImage } from '@homeaway/react-aspect-ratio-card';
import { ShortCarouselCard, AspectRatioCardTitle } from '../Carousel/CarouselCard';
import Placeholder from './Placeholder';
import './ListingCard.less';

const CNAME = 'ListingCard';

const ListingCard = ({
  onClick,
  averageRating,
  bedrooms,
  bathrooms,
  fullBathroomCount,
  listingUrl,
  imageUrl,
  name,
  rate,
  avgNight,
  reviewCount,
  sleeps,
  sleepCount
}) => (
  <ShortCarouselCard
    clickUrl={listingUrl}
    target={'_blank'}
    onClick={onClick}
  >
    {imageUrl
      ? <AspectRatioCardImage data-slot="figure" imageUri={imageUrl} />
      : <Placeholder data-slot={'figure'} />
    }
    <AspectRatioCardTitle data-slot={'caption'} title={name} />
    <div data-slot={'content'} className={`${CNAME}__content`}>
      <div className={`${CNAME}__rooms`}>
        {bedrooms && <span className="small">{bedrooms}</span>}
        {!!fullBathroomCount && <span className="small">{bathrooms}</span>}
        {!!sleepCount && <span className="small">{sleeps}</span>}
      </div>
      {!!averageRating &&
        <div className={`${CNAME}__review`}>
          <StarRating rating={averageRating} />
          <span className="small">{`(${reviewCount})`}</span>
        </div>
      }
      {rate &&
        <div className={`${CNAME}__price`}>
          <strong className={`${CNAME}__price__value`}>{rate}</strong>
          <span className="small">{avgNight}</span>
        </div>
      }
    </div>
  </ShortCarouselCard>
);

ListingCard.propTypes = {
  onClick: PropTypes.func,
  averageRating: PropTypes.number,
  bedrooms: PropTypes.string,
  bathrooms: PropTypes.string,
  listingUrl: PropTypes.string,
  fullBathroomCount: PropTypes.number,
  imageUrl: PropTypes.string,
  name: PropTypes.string,
  rate: PropTypes.string,
  avgNight: PropTypes.string,
  reviewCount: PropTypes.number,
  sleeps: PropTypes.string,
  sleepCount: PropTypes.number
};

export default ListingCard;
